import React, { useEffect, useState } from "react";
import DataComponent from "../../DataComponent";
import Icon from "../../Icon";
import LockIcon from "../../../assets/images/icon/lock.svg";
import ShieldIcon from "../../../assets/images/icon/shield.svg";
import { CardUnit, ColCard, Row } from "../../ContentLayout";
import { CardBody, CardHeader, CardTitle } from "reactstrap";
import { isEmpty } from "lodash";
import {
  getFinancesType,
} from "../../../apis/finances/auth";
import { viewLoading } from "../../../utils/loading";
import Badge from "../../Badge";
import { modifyTaxAccountantFinancesAccounts, postTaxAccountantFinancesAuth } from "../../../apis/tax-accountant-finance/auth";
import TaxAccountantFinancesNationalPensionCert from "../../FinancesCert/TaxAccountantFinancesNationalPensionCert";

export const findCertName = (cert) => {
  const certVal = String(cert);
  const cutIdx = certVal.lastIndexOf("(");

  return certVal.substring(0, cutIdx);
};

const TaxAccountNationalPensionCert = (props) => {
  const { getAccount, accountInfo, state } = props;

  const [isFinancesCertShow, setIsFinancesCertShow] = useState(false);


  const submit = (data) => {
    viewLoading(true);
    if (isEmpty(accountInfo)) {
      // 첫 등록
      const formData = {
        orgCd: "tax-accountant-nps",
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
        userId: data.userId,
        userPw: data.userPw,
        agentId: data.agentId,
        agentPw: data.agentPw,
      };

      postTaxAccountantFinancesAuth(formData)
        .then(() => {
          getAccount();
        })
        // .catch((err) => {
        //   console.log(err.response.message);
        // })
        .finally(() => viewLoading(false));
    } else {
      // 인증서 변경
      const formData = {
        loginMethod: "CERT",
        signCert: data.DER2PEM,
        signPri: data.KEY2PEM,
        signPw: data.password,
        signName: data.certName,
        signProvider: data.pub,
        signExpired: data.toDt,
        userId: data.userId,
        userPw: data.userPw,
        agentId: data.agentId,
        agentPw: data.agentPw,
      };
      modifyTaxAccountantFinancesAccounts(accountInfo.idx, formData).then(() => {
        getAccount();
      }).catch(() => { })
        .finally(() => viewLoading(false));
    }
  };


  return (
    <>
      <Row>
        <ColCard>

          <div className="home-tax-wrap">
            <CardHeader className="border-bottom-none">
              <CardTitle>
                <span className="card-header-title">인증서 정보</span>
              </CardTitle>
              <CardUnit>
                <DataComponent
                  field={{
                    type: "button",
                    label: isEmpty(accountInfo) ? "인증 정보 등록" : "인증 정보 변경",
                    size: "small",
                    color: "line",
                    action: () => {
                      getFinancesType("hometax").then((res) => {
                        setIsFinancesCertShow(true);
                      });
                    },
                  }}
                />
              </CardUnit>
            </CardHeader>
            <CardBody className="p-0 margin-top-14">
              <div className="cert-on-box">
                {!isEmpty(accountInfo) ? (
                  <>
                    <div className="left-site">
                      <div className="lock-shield-icon-wrap">
                        <Icon src={LockIcon} className="lock-icon" />
                        <div className="shield-icon-wrap">
                          <Icon src={ShieldIcon} className="shield-icon" />
                        </div>
                      </div>
                    </div>
                    <div className="right-site">
                      <p className="company-name">
                        {findCertName(accountInfo.signName) || accountInfo.signName}
                        {!isEmpty(state) && (
                          <Badge
                            className="margin-left-8"
                            color={state.color}
                            size="sm"
                            label={state.label}
                          />
                        )}
                      </p>
                      <p className="expire-date">
                        만료일<span className="date">{accountInfo.signExpired}</span>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="empty-cert">등록된 인증서가 없습니다.</div>
                  </>
                )}
              </div>
            </CardBody>

            <CardHeader className="border-bottom-none mt-45">
              <CardTitle>
                <span className="card-header-title">로그인 정보</span>
              </CardTitle>
            </CardHeader>
            <CardBody className="p-0 margin-top-14">
              <div className="cert-on-box">
                {!isEmpty(accountInfo) && (
                  <div className="empty-cert">
                    {/* 유저아이디 : <span className="font-bold">{accountInfo?.userId}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                    대리인 사업장 관리번호 : <span className="font-bold">{accountInfo?.agentId}</span>
                  </div>
                )}
              </div>
            </CardBody>
            <TaxAccountantFinancesNationalPensionCert
              isShow={isFinancesCertShow}
              toggle={setIsFinancesCertShow}
              submit={submit}
            />
          </div>
        </ColCard>
      </Row>



      {/* <div className="bank-account-connect-page">
              <div className="second-step-container">
                <CardHeader className="border-bottom-none">
                  <CardTitle>
                    <span className="card-header-title">로그인 정보</span>
                  </CardTitle>
                </CardHeader>
                <div
                  className="cert-id-login-container"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <div style={{ width: '48%' }}>
                    <h4 className="mb-10 ml-5">세무대리인</h4>
                    <form
                      className="cert-id-login-form"
                      style={{ width: '100%', marginLeft: 0 }}
                    >
                      <div className="input-wrap id">
                        <label className="input-label">관리번호</label>
                        <Input
                          className="id-input"
                          name="agentId"
                          value={certInfo.agentId}
                          onChange={handleOnChangeId}
                          placeholder="아이디를 입력해주세요"
                        />
                      </div>
                      <div className="input-wrap password">
                        <label className="input-label">패스워드</label>
                        <Input
                          className="password-input"
                          name="agentPw"
                          type={isHidePassword ? "password" : "text"}
                          value={certInfo.agentPw}
                          onChange={handleOnChangeId}
                          autoComplete="off"
                          placeholder="패스워드를 입력해주세요"
                        />
                        <span className="icon">
                          <i
                            className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                              } font-size-24`}
                            onClick={() => setIsHidePassword(!isHidePassword)}
                          />
                        </span>
                      </div>
                    </form>
                  </div>
                  <div style={{ width: '48%', marginLeft: 'auto' }}>
                    <h4 className="mb-10 ml-5">사용자</h4>
                    <form
                      className="cert-id-login-form"
                      style={{ width: '100%', marginLeft: 0 }}
                    >
                      <div className="input-wrap id">
                        <label className="input-label">아이디</label>
                        <Input
                          className="id-input"
                          name="userId"
                          value={certInfo.userId}
                          onChange={handleOnChangeId}
                          placeholder="아이디를 입력해주세요"
                        />
                      </div>
                      <div className="input-wrap password">
                        <label className="input-label">패스워드</label>
                        <Input
                          className="password-input"
                          name="userPw"
                          type={isHidePassword ? "password" : "text"}
                          value={certInfo.userPw}
                          onChange={handleOnChangeId}
                          autoComplete="off"
                          placeholder="패스워드를 입력해주세요"
                        />
                        <span className="icon">
                          <i
                            className={`mdi ${isHidePassword ? "mdi-eye" : "mdi-eye-off"
                              } font-size-24`}
                            onClick={() => setIsHidePassword(!isHidePassword)}
                          />
                        </span>
                      </div>
                    </form>
                  </div>
                </div> */}
    </>
  );
};

export default TaxAccountNationalPensionCert;